<template>
  <v-col
    :class="`pa-0 d-flex flex-fill flex-grow-${searchEnabled ? 1 : 0}`"
    cols="auto"
  >
    <v-col class="d-flex pa-0 flex-fill" cols="auto" v-if="searchEnabled">
      <v-menu bottom left>
        <template v-slot:activator="{ on, attrs }">
          <v-btn dark icon color="primary" v-bind="attrs" v-on="on">
            <v-icon>mdi-cog-outline</v-icon>
          </v-btn>
        </template>
        <v-list dense>
          <v-subheader>Search context:</v-subheader>
          <v-list-item
            :class="`${searchContext === context.value && 'grey lighten-3'}`"
            :key="context.value"
            @click="() => handleContextChange(context.value)"
            v-for="context of SearchContextsList"
          >
            <v-list-item-content>
              <v-list-item-title>
                {{ context.label }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-menu>
      <v-text-field
        autofocus
        hide-details
        class="pa-0 ma-0 ml-2"
        :label="`Search by ${RowsSearchContextLabelsMap[searchContext]}`"
        @input="handleSearchChange"
      />
    </v-col>
    <v-tooltip bottom color="white">
      <template v-slot:activator="{ on }">
        <v-btn v-on="on" icon color="primary" @click="handleSearchActive">
          <v-icon>mdi-magnify</v-icon>
        </v-btn>
      </template>
      <span class="black--text">Click to enable search.</span>
    </v-tooltip>
  </v-col>
</template>

<script>
import _ from 'lodash';
import {
  RowsSearchContextsMap,
  RowsSearchContextLabelsMap,
  DEFAULT_ROW_SEARCH_CONTEXT
} from '@/constants';

const SearchContextsList = [
  {
    label: RowsSearchContextLabelsMap[RowsSearchContextsMap.ORIG_NAME],
    value: RowsSearchContextsMap.ORIG_NAME
  },
  {
    label: RowsSearchContextLabelsMap[RowsSearchContextsMap.RHAPSODY_NAME],
    value: RowsSearchContextsMap.RHAPSODY_NAME
  },
  {
    label: RowsSearchContextLabelsMap[RowsSearchContextsMap.ORIG_CODE],
    value: RowsSearchContextsMap.ORIG_CODE
  }
];

export default {
  name: 'FileRowSearch',
  data() {
    return {
      SearchContextsList,
      RowsSearchContextLabelsMap,
      searchEnabled: false,
      searchContext: DEFAULT_ROW_SEARCH_CONTEXT,
      searchTerm: ''
    };
  },
  methods: {
    handleSearchActive() {
      this.searchEnabled = !this.searchEnabled;
    },
    handleContextChange(context) {
      if (this.searchContext !== context) {
        this.searchContext = context;

        if (this.searchTerm) {
          this.$emit('onSearchChange', this.searchContext, this.searchTerm);
        }
      }
    },
    handleSearchChange: _.debounce(function (value) {
      if (this.searchTerm !== value) {
        this.searchTerm = value.trim();

        this.$emit('onSearchChange', this.searchContext, this.searchTerm);
      }
    }, 500)
  }
};
</script>
